import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgWeightIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="weight_svg__nc-icon-wrapper">
      <path
        data-color="color-2"
        d="M61.812 3.416A1 1 0 0 0 61 3H3a1 1 0 0 0-.948 1.316C2.143 4.589 4.378 11 13 11h17v6h4v-6h17c8.622 0 10.857-6.411 10.948-6.684a1 1 0 0 0-.136-.9Z"
      />
      <path d="M54 19H10a2 2 0 0 0-2 2v38a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2V21a2 2 0 0 0-2-2ZM32 55a15 15 0 1 1 15-15 15 15 0 0 1-15 15Z" />
      <path
        data-color="color-2"
        d="M29 40c0-1.657 3-11 3-11s3 9.343 3 11a3 3 0 0 1-6 0Z"
      />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgWeightStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgWeightIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const WeightIcon: any = SvgWeightStyle;
export default WeightIcon;
